import React from 'react';
import {
  BooleanInput, SelectInput, CheckboxGroupInput, FormDataConsumer, TextInput, required
} from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';
import { ExpandMore } from '@material-ui/icons';
import {Accordion, AccordionSummary, AccordionDetails, Box} from "@material-ui/core";
import FilterCardTitle from '../common/filters/FilterCardTitle';
import { useForm } from 'react-final-form';

const useStyles = makeStyles({
  contrast: {
    backgroundColor: '#3e3e3e'
  }
});

const isSchedulerActive = (form) => form.scheduler && form.scheduler.active === true ? required() : []

export default function ReportScheduler({ record, ...props}) {
  const classes = useStyles(props);
  const form = useForm();
  const formData = form.getState().values;

  return (
    <Accordion className={classes.contrast}>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <FilterCardTitle title="Scheduler" values={record.scheduler? record.scheduler.active : false} />
      </AccordionSummary>
      <AccordionDetails>
        <Box style={{ width: '100%' }}>
          <BooleanInput source="scheduler.active" label="Active" style={{ color: 'white' }} alwaysOn resettable />
          <div style={{ width: '100%', overflow: 'hidden', display: 'flex', columnGap: '50px' }}>
            <div style={{flex: 0, alignSelf: 'center'}}>
              <SelectInput label="Schedule" source="scheduler.schedule"
                initialValue="daily"
                choices={[
                  { id: 'daily', name: 'Daily' },
                  { id: 'weekly', name: 'Weekly' },
                  { id: 'monthly', name: 'Monthly' }
                ]} />
            </div>
            <div style={{flex: 2}}>
              <FormDataConsumer>
                {({ formData }) => formData && formData.scheduler && formData.scheduler.schedule === 'weekly' &&
                <CheckboxGroupInput
                  label="Week days"
                  source="scheduler.week_days"
                  choices={[
                    {id: 0, name: 'Sunday'},
                    {id: 1, name: 'Monday'},
                    {id: 2, name: 'Tuesday'},
                    {id: 3, name: 'Wednesday'},
                    {id: 4, name: 'Thursday'},
                    {id: 5, name: 'Friday'},
                    {id: 6, name: 'Saturday'}
                  ]}
                  validate={required()}
                />
                }
              </FormDataConsumer>
            </div>
          </div>
          <div style={{ display: 'flex', columnGap: '50px' }}>
            <SelectInput label="Format" source="scheduler.format" initialValue="csv"
              choices={[
                { id: 'xls', name: 'Excel' },
                { id: 'csv', name: 'CSV' }
              ]} />
            <SelectInput label="Delivery" source="scheduler.delivery" initialValue="attachment"
              choices={[
                { id: 'attachment', name: 'Attachment only' },
                { id: 'link', name: 'Link only' },
                { id: 'both', name: 'Attachment & Link' }
              ]} />
          </div>
          <div>
            <TextInput style={{ width: '70%' }} source="scheduler.emails" label="Destination Notification Emails (comma separated)" validate={isSchedulerActive(formData)}/>
          </div>
        </Box>
      </AccordionDetails>
    </Accordion>
  )
};
